export default "__VITE_ASSET__Cuvf0uB9__"